import {v4 as uuidv4} from "uuid";

/**
 * @enum {string}
 * */
export const ArchiveFileType = Object.freeze({
    none: 'none',
    insurance: 'insurance',
    managementAgreement: 'managementAgreement',
    supplierAgreement: 'supplierAgreement',
    offer: 'offer',
    protocol: 'protocol',
});

export class UploadItem extends EventTarget {

    constructor(file, userID, displayname = null) {
        super();
        this.id = uuidv4();
        this.name = file.name;
        this.size = file.size;
        this.metadata = { userid: userID, displayname: displayname ?? file.name, type: null };
        this.file = file;
    }

    setUploadProgress(loaded) {
        this.loaded = loaded;
        this.dispatchEvent(new Event('change'));
    }

    setUploadError(error) {
        this.done = true;
        this.success = false;
        this.error = error;
        this.dispatchEvent(new Event('change'));
    }

    setUploadSuccess(resp) {
        this.done = true;
        this.success = true;
        this.dispatchEvent(new Event('change'));
    }

    /**
     * @param {ArchiveFileType} type
     * */
    setType(type) {
        this.metadata.type = type;
    }

    /**
     * @param {number} suffix
     * */
    addNameSuffix(suffix) {
        const parts = this.name.split('.');
        parts[parts.length-2] = `${parts[parts.length-2]}-${suffix}`;
        const newName = parts.join('.');
        if (this.name === this.metadata.displayname) {
            this.name = newName;
            this.metadata.displayname = newName;
        } else {
            this.name = newName;
            this.metadata.displayname = `${this.metadata.displayname}-${suffix}`;
        }
    }

    toJSON() {
        // NOTE: this use for generateUploadLinks request
        return {
            id: this.id,
            name: this.name,
            contentType: this.file.type,
            metadata: {
                ...this.metadata,
                type: this.metadata.type ?? ArchiveFileType.none
            },
        }
    }
}
